<div class="out" [@showHide]=" bShowUserNotification ? 'show' : 'hide' ">
  <div class="line">
    <img class="img" [src]="icon"  kzLib (click)="remove()">
    <div class="txt">
      {{_text}}
    </div>
  </div>
</div>
